import React from "react";
import { Avatar, Box, Tooltip } from "@mui/material";
import ENV from "../config/env";

// Foto de perfil pequeña + usuario, para listados ("Registrado por", "Ejecutivo"…).
// Sin foto (o con la imagen por defecto) se muestra un círculo con la inicial.
const COLORES = ["#00796b", "#1976d2", "#7b1fa2", "#e65100", "#455a64", "#c2185b", "#388e3c", "#5d4037"];

const colorDe = (texto) => {
  let h = 0;
  for (let i = 0; i < texto.length; i += 1) h = (h * 31 + texto.charCodeAt(i)) % 997;
  return COLORES[h % COLORES.length];
};

const urlFoto = (foto) => {
  const f = String(foto || "").trim();
  if (!f || /default-avatar/i.test(f)) return null;
  return /^https?:\/\//i.test(f) ? f : `${ENV.API_BASE_URL}${f}`;
};

export default function UsuarioAvatar({ usuario, foto, size = 22, sx }) {
  const nombre = String(usuario || "").trim();
  if (!nombre) return <>-</>;
  const src = urlFoto(foto);
  return (
    <Tooltip title={nombre} arrow disableInteractive>
      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, maxWidth: "100%", ...sx }}>
        <Avatar
          src={src || undefined} alt={nombre}
          imgProps={{ loading: "lazy" }}
          sx={{ width: size, height: size, fontSize: size * 0.5, fontWeight: 700, bgcolor: src ? "transparent" : colorDe(nombre.toLowerCase()), flexShrink: 0 }}
        >
          {nombre.charAt(0).toUpperCase()}
        </Avatar>
        <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{nombre}</Box>
      </Box>
    </Tooltip>
  );
}
